import {
  Button, Card, Col, Flex, Row, Typography
} from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useCurrentUser from "../../hooks/useCurrentUser";
import { appRoutes } from "../../constants/routes";

import classes from "./col.module.css";

const { Title } = Typography;

const DoctorPatients = () => {
  const { t } = useTranslation();
  const { data } = useCurrentUser();

  return (
    <Flex vertical className={classes.root}>
      <Title level={3}>{t("dashboardPage.patients.title")}</Title>
      <div className={classes.container}>
        <Row gutter={[16, 16]} className={classes.container}>
          {data?.patients?.map(item => (
            <Col xs={24} md={12} xl={8} key={`${item.name}_${item.surname}_${item.id}`}>
              <Card size="small" style={{ textAlign: "center" }}>
                <Title level={5} ellipsis>{`${item.name} ${item.surname}`}</Title>
                <Link to={appRoutes.messages} state={{ id: item.id }}>
                  <Button
                    type="primary"
                    icon={<MessageOutlined/>}
                    block
                  >
                    {t("dashboardPage.patients.messageButton")}
                  </Button>
                </Link>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </Flex>
  );
};

export default DoctorPatients;
